/* @flow */
import { Roles } from './defs';
import type { RoleList } from './defs';

// Manage CaaS
export const manageCaaSPermissions: RoleList = [Roles.SYSTEM_ADMIN, Roles.ASSET_MANAGER];
